export type OAuthInitializationDecision =
  | { type: 'auto-accept' }
  | { type: 'redirect-to-idp'; tenant: string }
  | { type: 'show-sso-tenant'; tenant: string }
  | { type: 'show-login' };

type OAuthInitializationInput = {
  canAutoAccept: boolean;
  ssoTeam?: string;
  ssoTeamHint?: string;
  storedSsoTenant?: string;
  isFreshHydraEntry: boolean;
  showSSO: boolean;
};

export const resolveOAuthInitializationDecision = ({
  /** Whether the OAuth request can be automatically accepted and the user can be logged in without further interaction */
  canAutoAccept,
  /** The explicitly specified SSO team (tenant). High priority and high signal -- an IT dept sets a bookmark or link that the user follows that includes this. */
  ssoTeam,
  /** The SSO team (tenant) hint from the OAuth request. The OAuth request includes this, but it may be stale or incorrect and the user needs a way to back out of it potentially. */
  ssoTeamHint,
  /** The SSO team (tenant) stored in localStorage from a previous SSO login. Can be used to pre-fill the SSO tenant login form. */
  storedSsoTenant,
  /** Whether this is a fresh entry into Hydra (the OAuth server), signaled by whether or not there's a login_challenge in the URL */
  isFreshHydraEntry,
  /** is SSO enabled in appConfig. In practice this is always true */
  showSSO,
}: OAuthInitializationInput): OAuthInitializationDecision => {
  if (canAutoAccept) {
    return { type: 'auto-accept' };
  }

  if (ssoTeam) {
    return { type: 'redirect-to-idp', tenant: ssoTeam };
  }

  if (ssoTeamHint && isFreshHydraEntry && showSSO) {
    return { type: 'show-sso-tenant', tenant: ssoTeamHint };
  }

  if (storedSsoTenant && isFreshHydraEntry && showSSO) {
    return { type: 'show-sso-tenant', tenant: storedSsoTenant };
  }

  return { type: 'show-login' };
};
